'use strict'
import { request } from '../../plugins/http'

export default async (message) => {
    return await request.post('/mensagemAtendimento', {message})
}